import React, { createRef } from "react";
import {
  Modal,
  Icon,
  Row,
  Col,
  TimePicker,
  DatePicker,
  Button,
  Input,
  Select,
  Spin,
  Form,
} from "antd";
import moment from "moment";
import { renderNotification } from "../components/orders/OrderTypeIcons";
import AddressForm_v2, { AddAddressForm } from "../components/common/AddressForm_v2";
import { updateOrderDetails_v2, verifyWhbasedZipCodes } from "../api/OrdersApi";
import { LineHaulApi } from "../api/LineHaulApi";
import Select_v2 from "../stories/components/Select_v2";
import AppointmentWindow from "../components/orders/AppointmentWindow";
import ReusableInput from "../stories/components/ReusableInput";
import AppConfig from "../config/AppConfig";
import PropTypes from "prop-types";
import { autoAssignDriverWarningModal, capacityError, isBetweenDates } from "./Common";
import AddressLocationDetails from "../components/orders/AddressLocationDetails";
import SearchAddress_v2 from "../stories/components/SearchAddress_v2";
import MobileInput_v2 from "../components/common/ReusableMobileInput";
import Checkbox_v2 from "../stories/components/Checkbox_v2";
import Button_v2 from "../stories/components/Button_v2";
import { normalizePhoneNumber } from "../helpers/common";
import { companyNameForCrossDockPick } from "../helpers/address";
import { isMultiDayOrder } from "../helpers/order_managemnt";
import {
  isOutboundDockAfterOnHandAtDestination,
  isOnHandAtDestinationBeforeOutboundDock,
} from "../helpers/orders";
import { isAppointmentMandatoryOrg } from "../helpers/appointmentOrgConfig";
import { ZipCodeWhModal } from "../components/orders/zipCodeWhModal";
import I18n from "./I18n";

const { confirm } = Modal;


class ContextualModal extends React.Component {
  dataRef = createRef(null);
  constructor(props) {    
    super(props);
    this.state = {
      modalVisible: this.props.openModal ? this.props.openModal : false,
      modalPosition: { top: 0, left: 0 },
      isActualTime: props.keyToBeUsed === "actual",
      isAppointment: props.keyToBeUsed === "appointment" ? true : false,
      // isCdkAppointment: props.labelTitle === "CDKAppointment" ? true : false,
      // isCrossDockReceived : props.labelTitle === "Received (CDK)" ? true : false,
      // isCrossDockPickedUp : props.labelTitle === "Picked Up" ? true : false,
      isETA: props.labelTitle === "ETA" ? true : false,
      labelTitle: props.labelTitle ? props.labelTitle : "Received",
      secondLabelTitle: "Departure",
      suppres_schedule_dates: "false",
      formValues: { ...this.props.prevFormVlaues },
      isLoading: false,
      autoAssignDriver: null,
      selectedWarehouseId: null,
      showWarningZipcodeModal: false,
      whZipcodeData: null,
      primaryLinehaulPath: null,
    };
    this.primaryLinehaulFetch = null;
  }

  customTimeObjChange = (field, date) => {
    if (!date) return;
    this.setState((prevState) => ({
      customTimeObj: {
        ...prevState.customTimeObj,
        [field]: moment(date).format("HH:mm"),
      },
    }));
  };

  onChange = (element, time, timeString) => {
    const { formValues } = this.state;
    const type = this.props.keyToBeUsed;
    this.setState({
      formValues: {
        ...formValues,
        [type]: {
          ...formValues[type],
          [element]: time,
        },
      },
    });
  };

  onModalClose = () => {
    this.setState({
      modalVisible: false,
    });
    this.props.onClose();
  };

  handleSuppresScheduleDates = (data) => {
    this.setState({
      suppres_schedule_dates: _.toString(data?.suppres_schedule_dates) || "true",
    },
      () => {
        this.handleSave();
      }
    );
  };

  handleCancel = () => {
    this.setState({
      modalVisible: false,
    });
    this.props.onClose();
  };

  componentDidUpdate(prevProps) {
    // Update modalVisible state when openModal prop changes
    if (prevProps.openModal !== this.props.openModal) {
      const newState = {
        modalVisible: this.props.openModal
      };
      if (this.props.openModal) {
        newState.isActualTime = this.props.keyToBeUsed === "actual";
        newState.isAppointment = this.props.keyToBeUsed === "appointment" ? true : false;
        newState.isETA = this.props.labelTitle === "ETA" ? true : false;
        newState.labelTitle = this.props.labelTitle ? this.props.labelTitle : "Received";
        newState.formValues = { ...this.props.prevFormVlaues };
        newState.isLoading = false;
        newState.primaryLinehaulPath = null;
        this.primaryLinehaulFetch = null;
      }
      this.setState(newState);
    }
  }

  onInputChange = (element, value) => {
    const type = this.props.keyToBeUsed;
    if (element === "stop_miles" && _.isEmpty(value)) value = 0;
    this.setState((prevState) => ({
      formValues: {
        ...prevState.formValues,
        [type]: {
          ...prevState.formValues[type],
          [element]: value,
        },
      },
    }), () => {
      if (type === "addressDetails" && element === "customer_zipcode") {
        this.fetchPrimaryLinehaulPath(value);
      }
    });
  };

  onKeyValueChange = (element, value) => {
    const { formValues } = this.state;
    const type = this.props.keyToBeUsed;
    this.setState({
      formValues: {
        ...formValues,
        [element]: value,
      },
    });
  };

  fetchPayloadKey = () => {
    if (this.props.formsToRender === "MultiStopParams") {
      return this.props.keyToBeUsed;
    }
    switch (this.props.keyToBeUsed) {
      case "received":
        return "received_at";
      case "pickupBy":
        return "pickup_by";
      case "onHand":
        return "on_hand_datetime";
      case "outboundDock":
        return "outbound_dock_datetime";
      case "deliveryBy":
        return "delivery_by";
      case "receivedCdk":
        return "cdk_actual_times";
      case "pickedUp":
        return "cdk_actual_times";
      case "appointment":
        return "appointment";
      case "addressDetails":
        return "order_location_params";
      case "addressLocation":
        return "location_creation_params";
      case "duration":
        return "service_duration_params";
      case "levelOfService":
        return "los_params";
      case "actual":
        return "actual_times";
      case "locationCode":
        return "acc_loc_code";
      case "address":
      case "consigneeAddress":
        return "consignee_details";
      case "contactName":
        return "consignee_details";
      case "contactPhone":
        return "consignee_details";
      case "stop_miles":
        return "stop_miles";
      default:
        return "params";
    }
  };

  handleValidate = (e) => {
  e?.preventDefault(); // Prevent default form submission behavior.

  const { form } = this.props; // Ensure `form` is passed down as a prop.
  const { formValues } = this.state;

  // Custom validation logic, if required
  const locationData = this.props.locationsRef?.current?.map(
    (ref) => ref.current && ref.current()
  ) || [];
  const errors = this.areAppointmentsInOrder(locationData);

  // Update error state
  if (errors?.length > 0) {
    this.setState({ validationErrors: errors });
  } else {
    this.setState({ validationErrors: [] });
  }

  // Validate fields in the form
  form.validateFieldsAndScroll((err, values) => {
    if (!err) {
      if (!errors?.length > 0) {
        this.handleSave(); // If no validation errors, proceed with saving.
      }
    } else {
      renderNotification(`Please fill all required fields`, "error");
    }
  });
};

areAppointmentsInOrder = (locations) => {
  // Example validation for appointments
  let errors = [];
  locations.forEach((loc, index) => {
    if (loc?.appointment && !loc?.appointment.appt_date) {
      errors.push(`${I18n.t("general.appointment")} is missing for location ${index + 1}`);
    }
  });
  return errors;
};

  handleAddressLinehaul = () => {
    confirm({
      title: "Changing the destination will remove the existing sub-order target details.",
      content: "Do you want to update these changes in the corresponding linehaul?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        this.setState({ lineHaulAddressChanges: "true" }, () => this.handleSave())
      },
      onCancel: () => {
        this.setState({ lineHaulAddressChanges: "false" }, () => this.handleCancel())
      },
    })
  }
  handleAutoAssignDriver = (value) => {
    this.setState({ autoAssignDriver: value ? "true" : "false" }, () => this.handleSave())
  }

  handleSave = () => {
    let error = false;
    const { currentOrder, location, currentOrg } = this.props;
    const { formValues } = this.state;
    const type = this.props.keyToBeUsed;  
    const payloadKey = this.fetchPayloadKey();
    const dataObject = formValues[type];
    let data = ['acc_loc_code'].includes(payloadKey) ? {[payloadKey] : ''} : { [payloadKey]: {} };
    switch (type) {
      // case "pickupBy":
      case "received":
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        break;
      case "pickupBy":
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        break;
      case "onHand":
        if (!dataObject?.start_date && !dataObject?.start_time) {
          data[payloadKey] = "";
          break;
        }
        if (!dataObject?.start_date || !dataObject?.start_time) {
          error = true;
          renderNotification("On-hand date and time are required", "error");
          break;
        }
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        {
          const otherLocs = this.props.currentOrder?.locations || [];
          const pickupLoc = otherLocs.find((loc) => loc.type_of_loc === "PICKUP");
          const deliveryLoc = otherLocs.find((loc) => loc.type_of_loc === "DELIVERY");
          const pickupTime = location?.type_of_loc === "PICKUP" ? data[payloadKey] : pickupLoc?.on_hand_datetime;
          const deliveryTime = location?.type_of_loc === "DELIVERY" ? data[payloadKey] : deliveryLoc?.on_hand_datetime;
          if (pickupTime && deliveryTime && !moment(deliveryTime).isAfter(moment(pickupTime))) {
            error = true;
            renderNotification(I18n.t("messages.on_hand_destination_after_pickup"), "error");
            break;
          }
          if (
            location?.type_of_loc === "DELIVERY" &&
            location?.outbound_dock_datetime &&
            !isOnHandAtDestinationBeforeOutboundDock(location, dataObject.start_date, dataObject.start_time)
          ) {
            error = true;
            renderNotification(I18n.t("messages.on_hand_destination_before_outbound_dock"), "error");
            break;
          }
        }
        break;
      case "outboundDock":
        if (!dataObject?.start_date && !dataObject?.start_time) {
          data[payloadKey] = "";
          break;
        }
        if (!dataObject?.start_date || !dataObject?.start_time) {
          error = true;
          renderNotification(I18n.t("messages.outbound_dock_date_time_required"), "error");
          break;
        }
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        {
          const onHandAtDest = location?.on_hand_datetime;
          if (
            onHandAtDest &&
            !isOutboundDockAfterOnHandAtDestination(location, dataObject.start_date, dataObject.start_time)
          ) {
            error = true;
            renderNotification(I18n.t("messages.outbound_dock_after_destination_on_hand"), "error");
            break;
          }
        }
        break;
      case "deliveryBy":
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        break;
      case "receivedCdk":

        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        break;
        case "pickedUp":
        data[payloadKey] =
          moment(dataObject.start_date).format("YYYY-MM-DD") +
          " " +
          moment(dataObject.start_time).format("HH:mm");
        break;
      case "levelOfService":
        data[payloadKey] = {
          ...dataObject,
        };
        break;
     case "stop_miles":
        data[payloadKey] = dataObject.stop_miles;
        break;
      case "duration":
        data[payloadKey] = {
          service_duration: dataObject.service_duration,
          los_code: dataObject.los_code,
          
        };
        break;
      case "locationCode":
        data.acc_loc_code = dataObject.acc_loc_code;
      break;
      // case "etaDetails":
      //   data[payloadKey] =  
      //   moment(dataObject.start_date).format("YYYY-MM-DD") +
      //   " " +
      //   moment(dataObject.start_time).format("HH:mm");
      case "actual":
        const arrivalDateTime = dataObject.start_date && dataObject.start_time && 
          moment(dataObject.start_date).isValid() && moment(dataObject.start_time).isValid()
          ? moment(dataObject.start_date).format("YYYY-MM-DD") + " " + moment(dataObject.start_time).format("HH:mm")
          : null;
        
        const departureDateTime = dataObject.end_date && dataObject.end_time && 
          moment(dataObject.end_date).isValid() && moment(dataObject.end_time).isValid()
          ? moment(dataObject.end_date).format("YYYY-MM-DD") + " " + moment(dataObject.end_time).format("HH:mm")
          : null;
        
        data[payloadKey] = {
          arrival_time: arrivalDateTime,
          departure_time: departureDateTime,
        };
        break;
      case "appointment":
        data[payloadKey] = {
          ...dataObject,
          appt_date: moment(dataObject.appt_date).format("YYYY-MM-DD 00:00:00"),
          suppres_schedule_dates: this.state.suppres_schedule_dates || "false",
        };
        const isOrgSpecific = isAppointmentMandatoryOrg(this.props.currentOrg?.code);
        // Expedite always needs a date (any org, any setting); appointment-mandatory is org-gated (MWE/FET).
        const isRequired =
          !!location?.appointment?.has_expedite ||
          (isOrgSpecific && !!location?.appointment?.has_appointment);
        if (isRequired && (data[payloadKey].appt_date === "Invalid date" || !data[payloadKey].appt_date)) {
          error = true;
          renderNotification(`${this.state.labelTitle || 'Appointment Date'} is required.`, 'error');
          break;
        }
        if (data[payloadKey].appt_date === "Invalid date") {
          error = false;
          break;
        } else {
          data[payloadKey].appt_date = moment(data[payloadKey].appt_date).isValid() ? data[payloadKey].appt_date : null;
        }
        if (isRequired && (!data[payloadKey].start_time || !data[payloadKey].end_time)) {
          error = true;
          renderNotification('Start and end times are required for the appointment.', 'error');
          break;
        } else {
          error = false;
          break;
        }
      case "addressDetails":
        data[payloadKey] = {
          customer_order_id: currentOrder.id,
          location_id: location?.id || "",
          type_of_loc: location?.type_of_loc || "",
          warehouse_id: this.state.selectedWarehouseId
              ? this.state.selectedWarehouseId
              : location?.type_of_loc === "DELIVERY"
              ? currentOrder?.customer_order_details?.target_warehouse ||
                currentOrder?.customer_order_details?.warehouse_id ||
                ""
              : null,
          acc_loc_code: location?.acc_loc_code || "",
          ...dataObject,
          address: _.pick(dataObject, [
            "customer_address_line_1",
            "customer_address_line_2",
            "customer_city",
            "customer_state",
            "customer_country",
            "customer_zipcode",
          ]),
        };
        data[payloadKey].customer_phone_one = normalizePhoneNumber(data[payloadKey].customer_phone_one);
        data[payloadKey].customer_phone_two = normalizePhoneNumber(data[payloadKey].customer_phone_two);
        break;
      case "address":
      case "consigneeAddress":
        data[payloadKey] = {
          city: dataObject.consignee_address_city,
          country: dataObject.consignee_address_country,
          address_line1: dataObject.consignee_address_line_1,
          address_line2: dataObject.consignee_address_line_2,
          state: dataObject.consignee_address_state,
          zipcode: dataObject.consignee_address_zipcode
        }
        break;
      case "contactName":
        data[payloadKey] = {
          first_name: dataObject.consignee_first_name
        };
        break;
      case "contactPhone":
        const phoneWithoutCountryCode = dataObject.consignee_phone_number.replace(/[^0-9]/g, '');
        const countryCodeLength = dataObject.consignee_phone_number.startsWith('+') ? 1 : 0;
        const isValid = phoneWithoutCountryCode.length - countryCodeLength >= 10;
        if (!isValid) {
          renderNotification(`Please enter valid phone number`, 'error')
          return;
        }
        data[payloadKey] = {
          phone: dataObject.consignee_phone_number ? normalizePhoneNumber(dataObject.consignee_phone_number) : ""
        }
        break;
      case "addressLocation":
        const hasRelease = ["OBT", "RT"].includes(currentOrder.label_code);
        const loc = this.dataRef.current()
        const autoAssignDriver = currentOrder?.type_of_order === "MS" ? { auto_assign_driver: this.state.autoAssignDriver } : {}
        data[payloadKey] = {
          customer_order_id: currentOrder.id,
          location_id: loc?.id || "",
          type_of_loc: loc?.type_of_loc || "",
          ...loc,
          is_recovery: loc?.type_of_loc === "PICKUP" && loc?.label_code === "REC",
          is_release: loc?.type_of_loc === "DELIVERY" &&
            hasRelease &&
            loc?.label_code === "TRANS",
          ...autoAssignDriver,
          loc_order_sequence: currentOrder?.locations?.length,
          // address: _.pick(loc, [
          //   "customer_address_line_1",
          //   "customer_address_line_2",
          //   "customer_city",
          //   "customer_state",
          //   "customer_country",
          //   "customer_zipcode",
          // ]),
        }
        // data[payloadKey].appt_date = loc?.appointment?.appt_date ? moment(loc.appointment.appt_date).format("YYYY-MM-DD 00:00:00") : "";
      case "pallets":
      case "quantity":
      case "surface_area":
      case "weight":
        data[type] = dataObject[type] || (type === "pallets" ? 0 : 1);
        break;
      default:
        break;
    }
    if (!error) {
      const lineHaulAddressChanges = this?.state?.lineHaulAddressChanges || false;
      let payload = {};
      if (payloadKey === "appointment") {
        const locations = (this.props.currentOrder?.locations || []).map((loc) => {
          if (loc.id === location.id) {
            return {
              ...loc,
              appointment: {
                ...loc.appointment,
                ...data[payloadKey],
              },
            };
          }
          return loc;
        })
        payload.wh_storage = isMultiDayOrder(locations);
      }

      payload = {
        ...payload,
        customer_order_params: {
          customer_order_id: currentOrder.id,
          warehouse_id : this.state.selectedWarehouseId || currentOrder?.customer_order_details?.warehouse_id || "",
          organization_id: currentOrg?.id || "",
          location_id: location?.id || location?.location_id ||  "",
        },
        [payloadKey]: data[payloadKey],
        add_zip_to_warehouse: this.state.whZipcodeData?.data?.warehouses?.length > 0 ? true : false,
      }

      if (currentOrder.type_of_order === "LH") {
        payload.allow_target_details_to_delete = lineHaulAddressChanges;
      }

      const isAppointmentChecked = payloadKey === "appointment" && Boolean(data[payloadKey]?.has_appointment);

      this.setState({
        isLoading: true,
      });
      updateOrderDetails_v2(currentOrder.id, payload).then((result) => {
        if (result.success) {
          renderNotification(
            `Order ${currentOrder.customer_order_details.customer_order_number} details has been updated`,
            "success"
          );
          // if (currentOrder?.id) {
          //   props.history.push(`/orders/${currentOrder.id}/edit`);
          // }
          this.setState({
            isLoading: false,
            onCancel: false,
            modalVisible: false,
          });
          this.props.setOpenAddressCredsModal(false);

          const shouldSyncLinehaul = type === "addressDetails" && this.isLinehaulOrder();
          if (shouldSyncLinehaul) {
            this.syncLinehaulRoutingAfterAddressSave();
          } else if (result.response) {
            this.handleResponseUpdate(result.response);
          } else {
            this.props.refreshDetails();
          }

          if (isAppointmentChecked) {
            if (typeof this.props.refreshDetails === "function") {
              this.props.refreshDetails();
            } else if (typeof this.props.fetchDetails === "function") {
              this.props.fetchDetails();
            }
          }

          if (!shouldSyncLinehaul && currentOrder.type_of_order === "LH" && lineHaulAddressChanges) {
            this.props.refreshDetails();
          }

          if (type === "levelOfService" && this.props.setVerifyLosFromScreen) {
            this.props.setVerifyLosFromScreen(false);
          }
        } else {
          this.setState({
            isLoading: false,
            modalVisible: true,
          });

          if (this.props.currentOrder.type_of_order === "LH" && ["target warehouse is mismatch"].includes(result.errors[0])) {
            this.handleAddressLinehaul();
          }

          if (result?.warnings && _.isArray(result?.warnings) && result?.warnings?.length > 0) {

            if (currentOrder.type_of_order === "MS" && result?.auto_assignment_warning) {
              autoAssignDriverWarningModal(result?.warnings, this.handleAutoAssignDriver);
              return;
            }

            capacityError(result?.warnings, this.handleSuppresScheduleDates);
            return;
          }
          renderNotification(
            result.errors,
            "error"
          );
          this.props.setOpenAddressCredsModal(true);
        }
      });
    }
  };

  checkAllowAppointment = (locObj, currentOrder) => {
    if(locObj){
      for (let i=0; i < locObj.loc_order_sequence; i++) {
        if (!currentOrder?.locations[i]?.appointment)
          return true
        return false
      }
    }
    
  }

  MilegeScreen = () => {
    const { location, keyToBeUsed } = this.props;
    const { formValues } = this.state;
    return (
      <Row type="flex" gutter={16} justify="end" data-testid={`${keyToBeUsed}-modal`}>
      <Col span={24}>
        <Input
          data-testid={`${keyToBeUsed}-input`}
          type="number"
          width="100%"
          addonAfter="Miles"
          onChange={(e) =>
            this.onInputChange("stop_miles", e.target.value)
          }
          value={formValues[keyToBeUsed].stop_miles}
        />
      </Col>
    </Row>
    );  
  }

  renderDynamicForm = () => {
    switch (this.props.formsToRender) {
      case "TimingsScreen":
        return this.TimingsScreen();
      case "LosandDurationScreen":
        return this.LosandDurationScreen();
      case "AddressDetailsScreen":
        return this.AddressDetailsScreen();
      case "AddressAddingForm":
        return this.AddressAddingForm()
      case "LocationCodeScreen":
        return this.locationCodeScreen();
      case "ConsigneeAddress":
        return this.ConsigneeAddress();
      case "ConsigneeName":
        return this.ConsigneeName();
      case "ConsigneeContact":
        return this.ConsigneeContact();
      case "MultiStopParams":
        return this.multiStopParams();
      case "MilesScreen":
        return this.MilegeScreen();
      default:
        return null;
    }
  };

  renderDynamicWidth = () => {
    switch (this.props.formsToRender) {
      case "TimingsScreen":
        return "350px";
      case "LosandDurationScreen":
        return "180px";
      case "MultiStopParams":
        return "180px";
      case "LocationCodeScreen":
        return "500px";
      case "ConsigneeAddress":
        return "450px";
      case "ConsigneeName":
        return "270px";
      case "ConsigneeContact":
        return "270px";
      case "AddressDetailsScreen":
        return "544px";
      case "MultiStopScreen":
        return "180px";
      case "MilesScreen":
        return "180px";
      default:
        return "500px";
    }
  };
  handleAppointmentTimeChange = (dateVal, customTimeObj,custom_time) => {
    if (customTimeObj) {
      this.setState({
        customTimeObj,      });
    }
    if (!dateVal || dateVal === "custom_time") {
          const formValues = _.cloneDeep(this.state.formValues);
          const type = this.props.keyToBeUsed;
          formValues[type] = {
            ...formValues[type],
            start_time: null,
            end_time: null,
            slot: null,
          };
          this.setState({ formValues });
          return;
        }
        if (custom_time === "custom_time") {
          
          const formValues = _.cloneDeep(this.state.formValues);
          const {start_time, end_time} = customTimeObj;
          const type = this.props.keyToBeUsed;
          formValues[type] = {
            ...formValues[type],
            start_time: start_time,
            end_time: end_time,
            slot: dateVal == "08:00-20:00" ? "ANY" : "CUSTOM",
          };
          this.setState({
            formValues,
          });
        }
    if (custom_time !== "custom_time") {
      const formValues = _.cloneDeep(this.state.formValues);
      const [startTime, endTime] = dateVal.split("-");
      const type = this.props.keyToBeUsed;
      formValues[type] = {
        ...formValues[type],
        start_time: startTime,
        end_time: endTime,
        slot: dateVal == "08:00-20:00" ? "ANY" : dateVal,
      };
      this.setState({
        formValues,
      });
    }
    
  };
    

  handleAppointmentChange = (name, value, dateVal) => {
    if(name === "appt_date") {
      const { currentPreplan, currentRoute } = this.props;
      let endDate = "";
      let startDate = "";
      if (currentPreplan?.delivery_start_date) {
        startDate = moment(currentPreplan.delivery_start_date).format(
          "YYYY-MM-DD"
        );
        endDate =
          currentPreplan.preplan_type === "single_day"
            ? startDate
            : moment(currentPreplan.delivery_end_date).format("YYYY-MM-DD");
      } else if (currentRoute?.r_scheduled_start_datetime && currentRoute?.r_scheduled_end_datetime) {
        startDate = moment(currentRoute.r_scheduled_start_datetime).format(
          "YYYY-MM-DD"
        );
        endDate = moment(currentRoute.r_scheduled_end_datetime).format(
          "YYYY-MM-DD"
        );
      }
      const selectedDate = moment(dateVal).format("YYYY-MM-DD");
      const isOutOfPreplan =
        !isEmpty(dateVal) &&
        startDate &&
        endDate &&
        !isBetweenDates(startDate, endDate, selectedDate);
      this.props.setOutofPreplan(isOutOfPreplan);
      this.handleOnChange(name, value, dateVal)
    } else {
      this.handleOnChange(name, value, dateVal)
    }
    
    
  }

  handleOnChange = (name, value, date) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const type = this.props.keyToBeUsed;
    formValues[type] = {
      ...formValues[type],
      [name]: date !== undefined ? date : value,
    };
    this.setState({
      formValues,
    });
  };

  TimingsScreen = () => {
    const { location, keyToBeUsed, config, selectedWarehouse, orgContext, orgSettings, organizationSettings } = this.props;
    const currentOrgSettings = orgContext?.orgSettings || orgSettings || organizationSettings || {};
    const showAppointmentCheckbox = currentOrgSettings?.show_appointment_checkbox_in_create_edit_order_screen === "true" || currentOrgSettings?.show_appointment_checkbox_in_create_edit_order_screen === true;
    const { formValues, customTimeObj} = this.state;
    const hasDeliveryZipcodesConfig =
      (config.validate_delivery_zipcode === "BOTH" ||
        location.address_type === config.validate_delivery_zipcode) &&
      config.delivery_zipcodes === "true";

    let appointmentTime =
      customTimeObj?.start_time && customTimeObj?.end_time
        ?{
          start_time: customTimeObj.start_time,
          end_time: customTimeObj.end_time
         }
        // : location?.appointment?.start_time && location?.appointment?.end_time
        // ? `${location.appointment.start_time}-${location.appointment.end_time}`
        : "";
        const locationData = keyToBeUsed === "appointment"
          ? {
              label_code: location.label_code,
              appointment: { ...(formValues[keyToBeUsed] || {}) },
            }
          : {
              ...location,
              [keyToBeUsed]: {
                ...(location?.[keyToBeUsed] || {}),
                ...(formValues[keyToBeUsed] || {})
              }
            };
    if (keyToBeUsed === 'appointment') {
      const start_time = formValues?.appointment?.start_time;
      const end_time = formValues?.appointment?.end_time;
      appointmentTime = appointmentTime ? appointmentTime : start_time && end_time ? {
        start_time: start_time,
        end_time: end_time
    } : "";
    }
    const defaultSlot = { label: "08:00 - 20:00", value: "08:00-20:00" }

    const slotOptions = (() => {
      if (!selectedWarehouse?.slot_details?.length) {
        return [defaultSlot];
      }

      const slots = selectedWarehouse.slot_details.map(({ start_time, end_time }) => ({
        label: `${start_time} - ${end_time}`,
        value: `${start_time}-${end_time}`,
      }));

      const includesFullDay = selectedWarehouse.slot_details.some(
        (slot) => slot.start_time === "08:00" && slot.end_time === "20:00"
      );

      if (!includesFullDay) {
        slots.push(defaultSlot);
      }

      return slots;
    })();

    const options = _.uniqBy(
      _.compact([
        ...slotOptions,
        !_.isEmpty(appointmentTime) && {
          label: `${appointmentTime.start_time} - ${appointmentTime.end_time}`,
          value: `${appointmentTime.start_time}-${appointmentTime.end_time}`,
        },
        { label: "Custom Time Slot", value: "custom_time" },
      ]),
      'value'
    );
    const targetDate = keyToBeUsed === "pickupBy" ? this.props.currentOrder?.customer_order_details?.received_at : keyToBeUsed === "deliveryBy" ? this.props.currentOrder?.customer_order_details?.received_at : null;
    const isCrossDock = location?.label_code === "CDK" || this.props.currentOrder?.label_code === "CDK" || this.props.currentOrder?.label_code === "WO";

    const hasAppointmentChecked =
      formValues[keyToBeUsed]?.has_appointment !== undefined
        ? Boolean(formValues[keyToBeUsed]?.has_appointment)
        : Boolean(this.props.location?.appointment?.has_appointment);

    const hasExpediteChecked =
      formValues[keyToBeUsed]?.has_expedite !== undefined
        ? Boolean(formValues[keyToBeUsed]?.has_expedite)
        : Boolean(this.props.location?.appointment?.has_expedite);

    let displayTitle = this.state.labelTitle;
    if (this.state.isAppointment) {
      if (
        this.state.labelTitle === "Service Date" ||
        this.state.labelTitle === "Appointment Date"
      ) {
        displayTitle = (hasAppointmentChecked || hasExpediteChecked)
          ? "Appointment Date"
          : "Service Date";
      }
    }

    return (
      <>
        <>{this.state.isActualTime ? "Arrival" : displayTitle}</>
        <Row
          data-testid={`${this.state.labelTitle}-modal`}
          gutter={[16, 16]}
          type="flex"
          justify="space-between"
          style={{ marginBottom: 0 }}
        >
          {!this.state.isAppointment && !isCrossDock && (
            <>
              <Col span={12}>
                <DatePicker
                  data-testid="date-picker"
                  onChange={(time, timeString) =>
                    this.onChange("start_date", time, timeString)
                  }
                  style={{ width: "100%" }}
                  value={
                    formValues[keyToBeUsed]?.start_date
                      ? moment(formValues[keyToBeUsed].start_date)
                      : null
                  }
                  format={AppConfig.dateFormat}
                  disabledDate={(current) => {                  
                    if (keyToBeUsed === "pickupBy" || keyToBeUsed === "deliveryBy") {
                      return targetDate
                        ? current && current.isBefore(targetDate, "day") 
                        : false;
                    } else if (keyToBeUsed === "onHand" && location?.type_of_loc === "DELIVERY") {
                      const pickupLoc = (this.props.currentOrder?.locations || []).find((loc) => loc.type_of_loc === "PICKUP");
                      return pickupLoc?.on_hand_datetime
                        ? current && current.isBefore(moment(pickupLoc.on_hand_datetime), "day")
                        : false;
                    } else if (keyToBeUsed === "outboundDock") {
                      return location?.on_hand_datetime
                        ? current && current.isBefore(moment(location.on_hand_datetime), "day")
                        : false;
                    }else if (keyToBeUsed === "received") {
                     const pickupByDate = this.props.currentOrder?.customer_order_details.pickup_by;
                     const deliveryByDate = this.props.currentOrder?.customer_order_details.delivery_by;
                       const earliestDate = pickupByDate && deliveryByDate
                       ? moment.min(moment(pickupByDate), moment(deliveryByDate))
                       : pickupByDate || deliveryByDate;
                       return earliestDate ? current && current.isAfter(moment(earliestDate), "day") : false;
                    }
                    return false;
                  }}
                />
              </Col>
              <Col span={12}>
                <TimePicker
                  data-testid="time-picker"
                  onChange={(time, timeString) =>
                    this.onChange("start_time", time, timeString)
                  }
                  style={{ width: "100%" }}
                  defaultOpenValue={moment(this.props.isMilitaryTime ? "00:00" : "00:00 AM", this.props.timeFormat)}
                  value={
                    formValues[keyToBeUsed]?.start_time
                      ? moment(formValues[keyToBeUsed].start_time, this.props.timeFormat)
                      : null
                  }
                  format={this.props.timeFormat}
                  use12Hours={!this.props.isMilitaryTime}
                />
              </Col>
            </>
          )}
          {!this.state.isActualTime && !this.state.isAppointment && isCrossDock && (

            <>
              <Col span={12}>
                <DatePicker
                  data-testid="start-date-picker"
                  onChange={(time, timeString) =>
                    this.onChange("start_date", time, timeString)
                  }
                  style={{ width: "100%" }}
                  value={
                    formValues[keyToBeUsed]?.start_date
                      ? moment(formValues[keyToBeUsed].start_date)
                      : null
                  }
                  format={AppConfig.dateFormat}
                  // disabledDate={(current) => {                  
                  //   if (keyToBeUsed === "pickupBy" || keyToBeUsed === "deliveryBy") {
                  //     return targetDate
                  //       ? current && current.isBefore(targetDate, "day") 
                  //       : false;
                  //   }else if (keyToBeUsed === "received") {
                  //    const pickupByDate = this.props.currentOrder?.customer_order_details.pickup_by;
                  //    const deliveryByDate = this.props.currentOrder?.customer_order_details.delivery_by;
                  //      const earliestDate = pickupByDate && deliveryByDate
                  //      ? moment.min(moment(pickupByDate), moment(deliveryByDate))
                  //      : pickupByDate || deliveryByDate;
                  //      return earliestDate ? current && current.isAfter(moment(earliestDate), "day") : false;
                  //   }
                  //   return false;
                  // }}
                />
              </Col>
              <Col span={12}>
                <TimePicker
                  data-testid="start-time-picker"
                  onChange={(time, timeString) =>
                    this.onChange("start_time", time, timeString)
                  }
                  style={{ width: "100%" }}
                  defaultOpenValue={moment(this.props.isMilitaryTime ? "00:00" : "00:00 AM", this.props.timeFormat)}
                  value={
                    formValues[keyToBeUsed]?.start_time
                      ? moment(formValues[keyToBeUsed].start_time, this.props.timeFormat)
                      : null
                  }
                  format={this.props.timeFormat}
                  use12Hours={!this.props.isMilitaryTime}
                />
              </Col>
            </>
          )}
          {this.state.isActualTime && !this.state.isAppointment && !isCrossDock && (
            <>

             <Col span={12} style={{paddingBottom: "0px"}} className="actual-time-departure">Departure</Col>
             <Col span={12} style={{paddingBottom: "0px"}}></Col>
             <Col span={12} style={{paddingTop: "0px"}}>
                <DatePicker
                  data-testid="end-date-picker"
                  onChange={(time, timeString) =>
                    this.onChange("end_date", time, timeString)
                  }
                  style={{ width: "100%" }}
                  value={
                    formValues[keyToBeUsed]?.end_date
                      ? moment(formValues[keyToBeUsed].end_date)
                      : null
                  }
                  format={AppConfig.dateFormat}
                  disabledDate={(current) => {
                    const startDate = formValues[keyToBeUsed]?.start_date;
                    return startDate
                      ? current && current.isBefore(moment(startDate), "day")
                      : false;
                  }}
                />
              </Col>
              <Col span={12} style={{paddingTop: "0px"}}>
                <TimePicker
                  data-testid="end-time-picker"
                  onChange={(time, timeString) =>
                    this.onChange("end_time", time, timeString)
                  }
                  style={{ width: "100%" }}
                  defaultOpenValue={moment(this.props.isMilitaryTime ? "00:00" : "00:00 AM", this.props.timeFormat)}
                  value={
                    formValues[keyToBeUsed]?.end_time
                      ? moment(formValues[keyToBeUsed].end_time,this.props.timeFormat)
                      : null
                  }
                  format={this.props.timeFormat}
                  use12Hours={!this.props.isMilitaryTime}
                />
              </Col>
            </>
          )}
          {this.state.isAppointment&& (          
            <Col span={24} className="appointment-window" style={{paddingTop: "0px"}}>
              <Row type="flex" gutter={[8, 8]}>
                <Col>
                  <AppointmentWindow
                    labelCode={displayTitle}
                    hideLabel={true}
                    options={options}
                    location={locationData}
                    hasDeliveryZipcodesConfig={hasDeliveryZipcodesConfig}
                    handleAppointmentTimeChange={this.handleAppointmentTimeChange}
                    handleOnChange={this.handleAppointmentChange}
                    appointmentTime={appointmentTime ? `${appointmentTime.start_time}-${appointmentTime.end_time}` : ''}
                    onChange={(time, timeString) =>
                      this.onChange("start_time", time, timeString)
                    }
                    currentPreplan={this.props.currentPreplan}
                    setOutofPreplan={this.props.setOutofPreplan}
                    setIsModified={this.props.setIsModified}
                    availableDatesInfo={_.pick(this.props.location, ["feasible_dates", "feasible_dow"])}
                    keyToUse={this.state.isAppointment ? "appointment" : "cdk_actual_times"}
                    actionType="view"
                  />
                </Col>
                {showAppointmentCheckbox && (
                  <Col>
                    <Checkbox_v2
                      label={"Appointment"}
                      handleChange={(val) =>
                        this.handleAppointmentChange("has_appointment", val, val)
                      }
                      checkValue={
                        formValues[keyToBeUsed]?.has_appointment !== undefined
                          ? Boolean(formValues[keyToBeUsed]?.has_appointment)
                          : Boolean(this.props.location?.appointment?.has_appointment)
                      }
                      isDisabled={hasExpediteChecked}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          )}
          {this.state.isETA && (
             <>
             <Col span={12}>
               <DatePicker
                 data-testid="start-date-picker"
                 onChange={(time, timeString) =>
                   this.onChange("start_date", time, timeString)
                 }
                 style={{ width: "100%" }}
                 value={
                   formValues[keyToBeUsed]?.start_date
                     ? moment(formValues[keyToBeUsed].start_date)
                     : null
                 }
                 format={AppConfig.dateFormat}
               />
             </Col>
             <Col span={12}>
               <TimePicker
                 data-testid="start-time-picker"
                 onChange={(time, timeString) =>
                   this.onChange("start_time", time, timeString)
                 }
                 style={{ width: "100%" }}
                 defaultOpenValue={moment(this.props.isMilitaryTime ? "00:00" : "00:00 AM", this.props.timeFormat)}
                 value={
                   formValues[keyToBeUsed]?.start_time
                     ? moment(formValues[keyToBeUsed].start_time, this.props.timeFormat)
                     : null
                 }
                 format={this.props.timeFormat}
                 use12Hours={!this.props.isMilitaryTime}

               />
             </Col>
           </>
          )}
        </Row>
      </>
    );
  };

  LosandDurationScreen = () => {
    const { location, keyToBeUsed } = this.props;
    const { formValues } = this.state;
    return !this.props.verifyLosFromScreen ? (
      <Row type="flex" gutter={16} justify="end" data-testid={`${keyToBeUsed}-modal`}>
        <Col span={24}>
          <Input
            data-testid={`${keyToBeUsed}-input`}
            addonAfter="Mins"
            type="number"
            width="100%"
            onChange={(e) =>
              this.onInputChange("service_duration", e.target.value)
            }
            value={formValues[keyToBeUsed].service_duration}
          />
        </Col>
      </Row>
    ) : (
      <Row type="flex" gutter={16} justify="end" data-testid={`${keyToBeUsed}-modal`}>
        <Col span={24} className="table-col-address custom-form-item">
          <Select_v2
            data-testid={`${keyToBeUsed}-input`}
            style={{ width: "100%" }}
            // suffixIcon={<Icon type="caret-down" style={{ color: "#576EC1" }} />}
            options={this.props.levelOfServices || []}
            // Value keyed by LOS id (not code): two sheets can share a code (account
            // "TT" vs Standard "SMF TRACTOR TRAILER (TT)"), so a code value would
            // highlight both. groupField renders account vs Standard OptGroups.
            valueField={"id"}
            codeField={"code"}
            labelField={"name"}
            groupField={"los_group"}
            // Menu wider than the (narrow) field so full tariff names + group
            // headers aren't truncated.
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ minWidth: 280 }}
            onChange={(val, option) => {
              // Backend resolves from los_code + rate_sheet_id (blank = account
              // scope). los_id is kept for the dropdown's display only.
              this.onInputChange("los_code", option?.code ?? val);
              this.onInputChange("los_id", option?.id ?? val);
              this.onInputChange("rate_sheet_id", option?.rate_sheet_id || "");
            }}
            value={(() => {
              const opts = this.props.levelOfServices || [];
              const fv = formValues[keyToBeUsed] || {};
              const byId = fv.los_id && opts.find((o) => o.id === fv.los_id);
              if (byId) return byId.id;
              const byCode = opts.find((o) => o.code === fv.los_code);
              return byCode?.id || fv.los_code || undefined;
            })()}
          />
        </Col>
      </Row>
    );
  };

  multiStopParams = () => {
    const { keyToBeUsed } = this.props;
    const { formValues } = this.state;
    let conditionApply = false;
    if (["weight", "surface_area"].includes(keyToBeUsed)) {
      conditionApply = true;
    }
    return !this.props.verifyLosFromScreen && (
      <Row type="flex" gutter={16} justify="end" data-testid={`${keyToBeUsed}-modal`}>
        <Col span={24}>
          <Input
            data-testid={`${keyToBeUsed}-input`}
            addonAfter={conditionApply && (keyToBeUsed === "weight" ? 'lbs' : 'in²')}
            type="number"
            width="100%"
            onChange={(e) => {
              if (!conditionApply) {
                const value = e.target.value.replace(/[^0-9]/g, '');
                this.onInputChange(keyToBeUsed, value)
              } else {
                const inputValue = e.target.value;
                const numericValue = Number(inputValue);
                const value = isNaN(numericValue) || inputValue === ''
                  ? ''
                  : Math.max(0, numericValue);
                this.onInputChange(keyToBeUsed, value);
              }
            }}
            onKeyDown={(e) => {
              // Allow only numbers, backspace, delete, tab, arrows
              if (!conditionApply) {
                if (!/[0-9]/.test(e.key) && 
                  !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                  e.preventDefault();
                }
              }
            }}
            value={formValues[keyToBeUsed][keyToBeUsed]}
            step ={!conditionApply && 1}
            precision={!conditionApply && 0}
          />
        </Col>
      </Row>
    );
  }

  locationCodeScreen = () => {
    const { location, keyToBeUsed } = this.props;
    const { formValues } = this.state;
    return (
      <Row type="flex" gutter={16} justify="end" data-testid={`${keyToBeUsed}-modal`}>
        <Col span={24}>
          <Form.Item label="Location Code">
          <ReusableInput
            data-testid={`${keyToBeUsed}-input`}
            // label={"Location Code"}
            type="text"
            name="acc_loc_code"
            width="100%"
            onChange={(e) =>
              this.onInputChange("acc_loc_code", e.target.value)
            }
            value={formValues.locationCode.acc_loc_code}
          />
          </Form.Item>
        </Col>
      </Row>
    );
  };

  handleOnChangeAddress = (selectedAddress) => {
    if (!selectedAddress || typeof selectedAddress !== "string") {
      console.error("Invalid address provided");
      return;
    }


    const { formValues } = this.state;
    const { currentOrder, location } = this.props;
    let addressArray = selectedAddress.split(",");
    const output = {
      zipcode: "",
      country: "",
      state: "",
      city: "",
      address_line2: "",
      address_line1: "",
    };
    const address_line1 = addressArray.splice(0, 1).join(", ");
    addressArray = addressArray.reverse();
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < addressArray.length; i++) {
      output[Object.keys(output)[i]] = addressArray[i];
    }
    output.address_line1 =
      addressArray.length > 5
        ? `${address_line1}, ${addressArray.slice(5).reverse().join(", ")}`
        : address_line1;

    this.setState({
      formValues: {
        [this.props.keyToBeUsed]: {
          ...formValues[this.props.keyToBeUsed],
          company_name: selectedAddress.company_name,
          customer_address_line_1:
            output?.address_line1 || "",
          customer_address_line_2:
            output?.address_line2 || "",
          customer_city: output?.city || "",
          customer_state: output?.state || "",
          customer_country: output?.country || "",
          customer_zipcode: output?.zipcode || "",
        },
      },
    }, () => {
      this.fetchPrimaryLinehaulPath(output?.zipcode);
    });

}
  AddressDetailsScreen = () => {
    const { location,currentOrder, form, orderTypeConfig, locObj } = this.props;
    const isCrossDock = location?.label_code === "CDK" || currentOrder?.label_code === "CDK" || currentOrder?.label_code === "WO";
    const isLinehaulCode = ["LH", "NLH","PLH", "LHD"].includes(orderTypeConfig.code);
    const isDstOrOrn = ["DST", "ORN"].includes(locObj.label_code);
    const isMilitaryTime =
      this.props?.organizationSettings?.is_military_time === "true" ||
      this.props?.orgSettings?.is_military_time === "true" ||
      this.props?.isMilitaryTime === true;

    const { formValues } = this.state;
    const {getFieldDecorator} = form;
    return (
      <AddAddressForm
        location={{
          ...location,
          ..._.get(formValues, `${this.props.keyToBeUsed}`),
        }}
        // location={location}
        onAddressSelect={this.onAddressSelect}
        onSelectForCrossDock={this.onSelectForCrossDock}
        handleOnChangeDirect={this.onInputChange}
        typeOfOrder = {currentOrder.type_of_order}
        handleOnChangeAddress={this.handleOnChangeAddress}
        isMilitaryTime={isMilitaryTime}
        showSearch={true}
        showPredefinedFields={false}
        getFieldDecorator={getFieldDecorator}
        isCrossDock={isCrossDock}
        linehaul_code={isLinehaulCode}
        linehaul_label={isDstOrOrn}
        hideWebResults={isDstOrOrn}
        disableAddressFields={isDstOrOrn}
        selectedWarehouseId={{ id: currentOrder?.customer_order_details?.warehouse_id }}
        orderTypeConfig={orderTypeConfig}
      />
    );
  };

  ConsigneeAddress = () => {
    const {formValues} = this.state;
    const { orderTypeConfig } = this.props;

    return (
      <SearchAddress_v2
        onSelect={this.consigneeAddressSelect}
        orderTypeConfig={orderTypeConfig}
      />
    )
  }

  ConsigneeName = () => {
    const {formValues, keyToBeUsed} = this.state

    return (
      <ReusableInput
        name="consignee_first_name"
        value={formValues.contactName.consignee_first_name}
        onChange={(e) =>
          this.onInputChange("consignee_first_name", e.target.value)
        }
      />
    )
  }

  ConsigneeContact = () => {
    const {formValues} = this.state

    return (
      <div className="consignee-mobile-edit">
        <MobileInput_v2
          value={formValues.contactPhone.consignee_phone_number}
          handleInputChange={(val,data) =>
            this.onInputChange("consignee_phone_number", val)
          }
        />
      </div>
    )
  }


  consigneeAddressSelect = (selectedAddress) => {
    const { formValues } = this.state;

    this.setState({
      formValues: {
        [this.props.keyToBeUsed]: {
          ...formValues[this.props.keyToBeUsed],
          consignee_address_city: selectedAddress?.l_address?.city || "",
          consignee_address_state: selectedAddress?.l_address?.state || "",
          consignee_address_country: selectedAddress?.l_address?.country || "",
          consignee_address_line_1: selectedAddress?.l_address?.address_line1 || '',
          consignee_address_line_2: selectedAddress?.l_address?.address_line2 || '',
          coordinates: selectedAddress?.l_address?.coordinates || [],
          consignee_address_zipcode: selectedAddress?.l_address?.zipcode || "",
        }
      }
    })
  };
  AddressAddingForm = () => {
    const { 
      location,
      warehouseFilter,
      orderTypeConfig,
      selectedWarehouse,
      locObj,
      levelOfServices,
      handleLocationUpdate,
      accessorialDefs,
      config,
      haveMultipleLocations,
      getAccountComponentDefs,
      currentAccount,
      handleUpdateWhStorage,
      targetWarehouse,
      setTargetWarehouse,
      orgContext,
      dtiversData,
      form,
      currentOrder,
    } = this.props;
    const {getFieldDecorator} = form;
    const { formValues } = this.state;
    const allowAppointment = this.checkAllowAppointment(locObj, currentOrder)

    return (
      <div className="address-adding-form">
        <AddressLocationDetails
          warehouses={warehouseFilter}
          orderTypeConfig={orderTypeConfig}
          selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
          // order={order}
          // locObj={locObj}
          locObj={{
            ...locObj,
            ..._.get(formValues, `${this.props.keyToBeUsed}`),
          }}
          levelOfServices={levelOfServices}
          handleLocationUpdate={handleLocationUpdate}
          getDataRef={this.dataRef}
          accountComponentAccessorial={accessorialDefs?.accountAccData || []}
          // showAccessorial={true} //{!(orderDetails.label_code !== "MS" && locations?.length === 1)}  
          config={config}
          haveMultipleLocations={haveMultipleLocations}
          displayComponents={accessorialDefs?.displayComponents || []}
          getFieldDecorator={getFieldDecorator}
          // showSidebySide={showSidebySide}
          accountConfig={config}
          getAccountComponentDefs={getAccountComponentDefs}
          dtiversData={dtiversData}
          form={form}
          orgContext={orgContext}
          currentAccount={currentAccount || {}}
          handleUpdateWhStorage={handleUpdateWhStorage}
          targetWarehouse={targetWarehouse}
          setTargetWarehouse={setTargetWarehouse}
          allowAppointment={allowAppointment}
          actionType="view"
          pickupWarehouseId={currentOrder?.customer_order_details?.warehouse_id}
        />
      </div>
    );
  }

  onAddressSelect = (selectedAddress) => {
    const { formValues } = this.state;
    const { currentOrder, location } = this.props;
    const orderLabel = currentOrder?.customer_order_details?.order_label
    this.setState({
      formValues: {
        [this.props.keyToBeUsed]: {
          ...formValues[this.props.keyToBeUsed],
          company_name: selectedAddress.company_name,
          customer_email: selectedAddress.email,
          customer_address_line_1:
            selectedAddress?.l_address?.address_line1 || "",
          customer_address_line_2:
            selectedAddress?.l_address?.address_line2 || "",
          customer_city: selectedAddress?.l_address?.city || "",
          customer_state: selectedAddress?.l_address?.state || "",
          customer_country: selectedAddress?.l_address?.country || "",
          customer_zipcode: selectedAddress?.l_address?.zipcode || "",
          address_type:
            selectedAddress?.l_address?.address_type || selectedAddress?.address_type || "COMMERCIAL",
          operational_use: selectedAddress?.operational_use || "FINAL_MILE",
          customer_phone_one: selectedAddress.phone,
          customer_phone_two: selectedAddress.phone_2,
          customer_first_name: selectedAddress.name,
          warehouse_id: selectedAddress._id,
          l_type: ['OR', 'OD'].includes(orderLabel) ? (selectedAddress?.l_type === "WH" ? "PWL" : "CS" ):
           orderLabel == "LH" || orderLabel == "NLH"
              ? "WH"
              : "CS",
          label_code: location.label_code,
          type_of_loc: location.type_of_loc,
          loc_order_sequence: location.loc_order_sequence,
        },
      },
    }, () => {
      this.fetchPrimaryLinehaulPath(selectedAddress?.l_address?.zipcode);
    });
    // if(selectedAddress?.l_address?.zipcode){
    //   verifyZipcode(selectedAddress.l_address.zipcode)
    //   getAvailableDates(selectedAddress.l_address.zipcode)
    // }
  };

  isLinehaulOrder = () => {
    const { currentOrder, orderTypeConfig } = this.props;
    const orderLabel = String(
      orderTypeConfig?.code
      || currentOrder?.order_label
      || currentOrder?.customer_order_details?.order_label
      || ""
    );
    return ["LH", "NLH", "PLH", "LHD", "PLHD"].includes(orderLabel) || orderLabel.includes("LH");
  };

  formatServiceDate = (raw) => {
    if (!raw) return null;
    const rawStr = String(raw);
    const ymd = rawStr.match(/^(\d{4}-\d{2}-\d{2})/);
    if (ymd) return ymd[1];
    const parsed = moment(raw);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
  };

  resolvePickupServiceDate = (order) => {
    const pickup = (order?.locations || []).find((loc) => loc.type_of_loc === "PICKUP");
    if (!pickup) return null;
    const isCompleted = String(pickup.status || "").toUpperCase() === "COMPLETED";
    const raw = isCompleted
      ? (pickup.actual_end_datetime || pickup.actual_end_date)
      : (pickup.appointment?.appt_date || pickup.appointments?.[0]?.appt_date);
    return this.formatServiceDate(raw);
  };

  resolveLinehaulZips = (editedZip) => {
    const { currentOrder, location } = this.props;
    const formZip = editedZip || this.state.formValues?.addressDetails?.customer_zipcode;
    const pickupLoc = (currentOrder?.locations || []).find((loc) => loc.type_of_loc === "PICKUP");
    const deliveryLoc = (currentOrder?.locations || []).find((loc) => loc.type_of_loc === "DELIVERY");
    const originZip = location?.type_of_loc === "PICKUP"
      ? (formZip || pickupLoc?.address?.zipcode)
      : pickupLoc?.address?.zipcode;
    const destZip = location?.type_of_loc === "DELIVERY"
      ? (formZip || deliveryLoc?.address?.zipcode)
      : deliveryLoc?.address?.zipcode;
    return { originZip, destZip };
  };

  fetchPrimaryLinehaulPath = (editedZip) => {
    const { currentOrg } = this.props;
    if (!this.isLinehaulOrder() || !currentOrg?.id) return Promise.resolve(null);

    const zip = String(editedZip || "").trim();
    if (zip && zip.length < 5) return Promise.resolve(null);

    const { originZip, destZip } = this.resolveLinehaulZips(editedZip);
    if (!originZip || !destZip) return Promise.resolve(null);

    this.setState({ primaryLinehaulPath: null });
    const request = LineHaulApi.fetchWarehousesByZipcode(currentOrg.id, originZip, destZip)
      .then((whResult) => {
        if (!whResult?.success || !whResult.data?.origin_warehouse || !whResult.data?.destination_warehouse) {
          return null;
        }
        return LineHaulApi.fetchLineHaulLanesJava(
          currentOrg.id,
          whResult.data.origin_warehouse,
          whResult.data.destination_warehouse
        );
      })
      .then((laneResult) => {
        if (!laneResult) return null;
        const paths = laneResult?.data?.paths || laneResult?.paths || [];
        const primaryPath = (Array.isArray(paths) ? paths : []).find((path) => Boolean(path?.is_primary)) || null;
        this.setState({ primaryLinehaulPath: primaryPath });
        return primaryPath;
      })
      .catch((err) => {
        console.error("Failed to fetch primary linehaul path:", err);
        return null;
      });

    this.primaryLinehaulFetch = request;
    return request;
  };

  buildLinehaulTrackingPayload = (primaryPath, serviceDate, currentOrder) => {
    const pathId = String(primaryPath?.path_id || primaryPath?._id || primaryPath?.id || "");
    const trackingInfo = currentOrder?.linehaul_tracking_info || {};
    const existingTariff = trackingInfo.tariff || {};
    const tariffData = {
      los_id: existingTariff.los_id || existingTariff.id || "DEFAULT",
      los_name: existingTariff.los_name || existingTariff.name || "DEFAULT",
      los_code: existingTariff.los_code || existingTariff.code || "DEFAULT",
    };
    const formattedLegs = (primaryPath?.legs || []).map((leg) => ({
      routing_id: String(leg.routing_id || leg._id || leg.id || ""),
      origin_id: String(leg.origin_id || ""),
      origin_code: String(leg.origin_code || ""),
      destination_id: String(leg.destination_id || ""),
      destination_code: String(leg.destination_code || ""),
      ...(serviceDate ? { linehaul_service_date: serviceDate } : {}),
    }));

    return {
      customer_order_id: currentOrder.id,
      linehaul_path_id: pathId,
      lh_routing_path_id: pathId,
      is_linehaul_special: Boolean(
        currentOrder?.is_linehaul_special
        || currentOrder?.customer_order_details?.is_linehaul_special
      ),
      linehaul_tracking: {
        path_id: pathId,
        legs: formattedLegs,
        tariff: tariffData,
        ...(serviceDate ? { service_date: serviceDate } : {}),
      },
    };
  };

  syncLinehaulRoutingAfterAddressSave = async () => {
    const { currentOrder } = this.props;
    if (!this.isLinehaulOrder() || !currentOrder?.id) {
      if (typeof this.props.refreshDetails === "function") this.props.refreshDetails();
      return;
    }

    try {
      let primaryPath = this.state.primaryLinehaulPath;
      if (!primaryPath && this.primaryLinehaulFetch) {
        primaryPath = await this.primaryLinehaulFetch;
      }
      if (!primaryPath) {
        primaryPath = await this.fetchPrimaryLinehaulPath(
          this.state.formValues?.addressDetails?.customer_zipcode
        );
      }
      if (!primaryPath) {
        if (typeof this.props.refreshDetails === "function") this.props.refreshDetails();
        return;
      }

      const serviceDate = this.resolvePickupServiceDate(currentOrder);
      const payload = this.buildLinehaulTrackingPayload(primaryPath, serviceDate, currentOrder);
      const result = await LineHaulApi.updateLinehaulRoutingLane(payload);
      if (!result?.success) {
        renderNotification(result?.message || result?.errors || "Failed to update linehaul routing", "error");
        if (typeof this.props.refreshDetails === "function") this.props.refreshDetails();
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 3000));
      await LineHaulApi.fetchLineHaulRealTimeTracking(currentOrder.id);
      if (typeof this.props.refreshDetails === "function") {
        this.props.refreshDetails();
      }
    } catch (err) {
      console.error("Failed to sync linehaul routing after address save:", err);
      if (typeof this.props.refreshDetails === "function") this.props.refreshDetails();
    }
  };

  onSelectForCrossDock = (selectedAddress) => {
    const { formValues } = this.state;
    const { currentOrder } = this.props;
    const orderLabel = currentOrder?.customer_order_details?.order_label;
    const prior = formValues[this.props.keyToBeUsed] || {};

    this.setState({
      formValues: {
        ...formValues,
        [this.props.keyToBeUsed]: {
          ...prior,
          company_name: companyNameForCrossDockPick(selectedAddress, prior.company_name),
          customer_email: selectedAddress?.email,
          customer_phone_one: selectedAddress?.phone,
          l_type: ['OR', 'OD'].includes(orderLabel) ? (selectedAddress?.l_type === "WH" ? "PWL" : "CS" ) :
           orderLabel === "LH" || orderLabel === "NLH"
              ? "WH"
              : "CS",
        },
      },
    });
  }

  /**
   * Handles different types of updates from the API response
   * @param {Object} response - The API response object
   */
  handleResponseUpdate(response) {
    const locationId = this.props.location?.id || "";
    
    // Define update handlers for different response types
    const updateHandlers = [
      {
        check: 'location_details',
        handler: () => {
          this.props.updateLocationDetails && this.props.updateLocationDetails(response.location_details);
        }
      },
      {
        check: 'duration_details',
        handler: () => {
          const durationDetailsWithLocation = {
            ...response.duration_details,
            location_id: locationId
          };
          this.props.updateDurationDetails && this.props.updateDurationDetails(durationDetailsWithLocation);
        }
      },
      {
        check: 'received_at',
        handler: () => {
          const receivedDetails = {
            received_at: response.received_at,
            location_id: locationId
          };
          this.props.updateReceivedDetails && this.props.updateReceivedDetails(receivedDetails);
        }
      },
      {
        check: 'delivery_by',
        handler: () => {
          const deliverByDetails = {
            delivery_by: response.delivery_by,
            location_id: locationId
          };
          this.props.updateDeliverByDetails && this.props.updateDeliverByDetails(deliverByDetails);
        }
      },
            {
        check: 'pickup_by',
        handler: () => {
          const pickupByDetails = {
            pickup_by: response.pickup_by,
            location_id: locationId
          };
          this.props.updatePickupByDetails && this.props.updatePickupByDetails(pickupByDetails);
        }
      },
      {
        check: (resp) => Object.prototype.hasOwnProperty.call(resp, 'on_hand_datetime'),
        handler: () => {
          const onHandDetails = {
            on_hand_datetime: response.on_hand_datetime,
            location_id: response.location_id || locationId
          };
          this.props.updateOnHandDetails && this.props.updateOnHandDetails(onHandDetails);
        }
      },
      {
        check: (resp) => Object.prototype.hasOwnProperty.call(resp, 'outbound_dock_datetime'),
        handler: () => {
          const outboundDockDetails = {
            outbound_dock_datetime: response.outbound_dock_datetime,
            location_id: response.location_id || locationId
          };
          this.props.updateOutboundDockDetails && this.props.updateOutboundDockDetails(outboundDockDetails);
        }
      },
      {
        check: 'appointment_details',
        handler: () => {
          const appointmentDetails = {
            appt_date: response.appointment_details.appt_date,
            start_time: response.appointment_details.start_time,
            end_time: response.appointment_details.end_time,
            slots: response.appointment_details.slots,
            location_id: response.appointment_details.location_id,
            confirmed: response.appointment_details.confirmed,
            has_expedite: response.appointment_details.has_expedite
          };
          this.props.updateAppointmentDetails && this.props.updateAppointmentDetails(appointmentDetails);
        }
      },
      {
        check: (resp) => resp.arrival_time || resp.departure_time,
        handler: () => {
          const actualDetails = { location_id: locationId };
          
          if (response.arrival_time) {
            actualDetails.actual_start_datetime = response.arrival_time;
          }
          
          if (response.departure_time) {
            actualDetails.actual_end_datetime = response.departure_time;
          }
          
          this.props.updateActualDetails && this.props.updateActualDetails(actualDetails);
        }
      },
      {
        check: 'consignee_first_name',
        handler: () => {
          const consigneeNameDetails = {
            consignee_first_name: response.consignee_first_name
          };
          this.props.updateConsigneeName && this.props.updateConsigneeName(consigneeNameDetails);
        }
      },
      {
        check: 'consignee_phone_number',
        handler: () => {
          const consigneePhoneDetails = {
            consignee_phone_number: response.consignee_phone_number
          };
          this.props.updateConsigneePhone && this.props.updateConsigneePhone(consigneePhoneDetails);
        }
      },
      {
        check: 'consignee_address_line_1',
        handler: () => {
          const consigneeAddressDetails = {
            consignee_address_line_1: response.consignee_address_line_1,
            consignee_address_line_2: response.consignee_address_line_2 || "",
            consignee_address_zipcode: response.consignee_address_zipcode || "",
            consignee_address_city: response.consignee_address_city || "",
            consignee_address_state: response.consignee_address_state || "",
            consignee_address_country: response.consignee_address_country || "",
            consignee_address_coordinates: response.consignee_address_coordinates || []
          };
          this.props.updateConsigneeAddress && this.props.updateConsigneeAddress(consigneeAddressDetails);
        }
      }
    ];

    // Find and execute the first matching handler
    const matchingHandler = updateHandlers.find(handler => {
      if (typeof handler.check === 'function') {
        return handler.check(response);
      }
      return response[handler.check];
    });

    if (matchingHandler) {
      matchingHandler.handler();
    } else {
      // Fallback to refreshDetails if no specific handler matches
      this.props.refreshDetails();
    }
  }

verifyWhZipcode = async (orgId, zipcode, warehouseId, typeOfLoc) => {
  try {
    this.setState({ isLoading: true });

    if (!zipcode) {
      renderNotification(I18n.t("errors.ZipCode_required"), "error");
      this.setState({ isLoading: false });
      return;
    }

    const result = await verifyWhbasedZipCodes(
      orgId,
      zipcode,
      warehouseId,
      typeOfLoc
    );

    this.setState({
      whZipcodeData: result,
      isLoading: false,
    });

    if (!result?.data?.warehouses?.length) {
      this.handleValidate();
    }else {
      this.setState({
        showWarningZipcodeModal: result?.data?.warehouses?.length > 0,
      })
    }

  } catch (error) {
    console.error(`${I18n.t("general.Warehouse")} zipcode verification failed`, error);
    this.setState({ isLoading: false });
  }
};

  render() {
    const { location,currentOrder, form , orgContext} = this.props;
    const isCrossDock = location?.label_code === "CDK" || currentOrder?.label_code === "CDK" || currentOrder?.label_code === "WO";
    const verifyZipcodeForPLHD = currentOrder?.customer_order_details?.order_label === "PLHD" && orgContext?.orgSettings?.add_zip_to_warehouse === "true" && this.props.locObj.customer_zipcode !== this.state.formValues?.addressDetails?.customer_zipcode;
    const allowedScreens = ["AddressDetailsScreen"];
    return (
      <div>
        <Modal
          className="address-details-modal"
          visible={this.state.modalVisible}
          closable={false}
          onCancel={this.handleCancel}
          keyboard={true}
          title={
            this.props.formsToRender === "AddressDetailsScreen"
                    ? (isCrossDock ? `Edit Cross Dock / ${I18n.t('general.warehouse')} Storage Details`:`Edit Address`)
                    : null
          }
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                padding: this.props.formsToRender === "AddressDetailsScreen" ? "0px 8px" : "0px",
              }}
            >
              <Row type="flex" justify="end" align="middle">
                <Col>
                  <Button_v2
                    data-testid="address-cancel-button"
                    type={
                      this.props.formsToRender === "AddressDetailsScreen"
                        ? "primary"
                        : "link"
                    }
                    onClick={this.handleCancel}
                    className={
                      this.props.formsToRender === "AddressDetailsScreen"
                        ? "flat medium-btn"
                        : ""
                    }
                    style={
                      this.props.formsToRender !== "AddressDetailsScreen"
                        ? {
                            color: "#90A2E2",
                            fontWeight: 600,
                          }
                        : {}
                    }
                    text="Cancel"
                  />
                  <Button_v2
                    data-testid={`address-${this.props.formsToRender === "AddressDetailsScreen" ? "update" : "save"}-button`}
                    type={
                      this.props.formsToRender === "AddressDetailsScreen"
                        ? "primary"
                        : "link"
                    }
                  onClick={(e) => {
                    if (verifyZipcodeForPLHD && allowedScreens.includes(this.props.formsToRender)) {
                      this.verifyWhZipcode(
                        this.props.currentOrg?.id,
                        this.state?.formValues?.addressDetails?.customer_zipcode,
                        this.props.currentOrder.customer_order_details?.warehouse_id,
                        this.state?.formValues?.addressDetails?.type_of_loc,
                      );
                    } else if (this.props.formsToRender === "AddressDetailsScreen") {
                      this.handleValidate(e);
                    } else {
                      this.handleSave();
                    }
                  }}
                    className={
                      this.props.formsToRender === "AddressDetailsScreen"
                        ? "raised medium-btn"
                        : ""
                    }
                    style={
                      this.props.formsToRender !== "AddressDetailsScreen"
                        ? {
                            color: "#90A2E2",
                            fontWeight: 600,
                          }
                        : {}
                    }
                    text={
                      this.props.formsToRender === "AddressDetailsScreen"
                        ? "Update Address"
                        : "Save"
                    }
                  />
                </Col>
              </Row>
            </div>
          }
          style={{
            position: "absolute",
            top: this.props.modalPosition.top,
            left: this.props.modalPosition.left,
            margin: 0,
          }}
          mask={true}
          maskClosable={false}
          bodyStyle={{ padding: 6, borderRadius: 10 }}
          width={this.renderDynamicWidth()}
        >
          <Spin spinning={this.state.isLoading}>
            {this.renderDynamicForm()}           
          </Spin>
        </Modal>
        {/* whzips */}
        {this.state.whZipcodeData?.data && (
          <Modal
            className="wh-zipcode-modal"
            title={""}
            centered
            closable={false}
            maskClosable={false}
            visible={this.state.whZipcodeData?.data?.warehouses?.length > 0}
            width={600}
            footer={
              <div style={{ display: "flex", flexDirection: "column", padding: "0px 16px" }}>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                  <Row type="flex" justify="end">
                    <Col>
                      <Button_v2
                        onClick={() => {
                          this.setState({ whZipcodeData: null });
                        }}
                        className="flat medium-btn"
                        text="Cancel"
                      />
                      <Button_v2
                      onClick={(e) => {
                          this.handleValidate(e);
                        }}
                        className="raised medium-btn"
                        text={"Proceed"}
                        disabled={this.state?.selectedWarehouseId ? false : true} 
                        loading={this?.state?.isLoading}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          >
            <ZipCodeWhModal
              type={this.props.locObj?.type_of_loc}
              warehouses={this.state.whZipcodeData?.data.warehouses || []}
              setSelectedWarehouseId={(id) => this.setState({ selectedWarehouseId: id })}
              selectedWarehouseId={this.state?.selectedWarehouseId}
              warningText={this.state?.whZipcodeData?.data?.warning}
            />
          </Modal>
        )}
      </div>
    );
  }
}

ContextualModal.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,
  updateLocationDetails: PropTypes.func,
  updateDurationDetails: PropTypes.func,
  updateReceivedDetails: PropTypes.func,
  updateDeliverByDetails: PropTypes.func,
  updateOnHandDetails: PropTypes.func,
  updateOutboundDockDetails: PropTypes.func,
  updateAppointmentDetails: PropTypes.func,
  updateActualDetails: PropTypes.func,
  updateConsigneeName: PropTypes.func,
  updateConsigneePhone: PropTypes.func,
  updateConsigneeAddress: PropTypes.func,
};
ContextualModal.defaultProps = {
  currentPreplan: {},
  currentRoute: {},
  setOutofPreplan: () => {},
  setIsModified: () => {},
  updateLocationDetails: null,
  updateDurationDetails: null,
  updateReceivedDetails: null,
  updateDeliverByDetails: null,
  updateOnHandDetails: null,
  updateOutboundDockDetails: null,
  updateAppointmentDetails: null,
  updateActualDetails: null,
  updateConsigneeName: null,
  updateConsigneePhone: null,
  updateConsigneeAddress: null,
};

export default ContextualModal;
